import React, { Component, useContext, useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate, Navigate} from 'react-router-dom';

import './systeam.css';

//sites

import Header from './components/header';
import Footer from './components/footer';

import NavbarResponsive from './components/navbarresponsive';

import SysMobil from './components/sysmobil';
import Home from './components/landingpage';
import Kontakt from './components/kontakt';
import Impressum from './components/impressum';
import About from './components/about';
import Tutorials from './components/tutorials';


function systeamWebsite() {
  return (
    <div className="wrapper">

                          <Header  />

                          


                            <Routes >
                                <>
                                
                                  <Route 
                                    path="/"
                                    element = {<Home/>}
                                  />

                                  <Route 
                                    path="/impressum"
                                    element = {<Impressum/>}
                                  />

                                  <Route
                                    path="sysmobil"
                                    element = {<SysMobil/>}
                                  />  



                                  <Route 
                                    path="/about"
                                    element = {<About/>}
                                  />
                      
                                  <Route 
                                    path="/kontakt"
                                    element = {<Kontakt/>}
                                  />
                                  
                                  <Route 
                                    path="/tutorials"
                                    element = {<Tutorials/>}
                                  />
                                  

                                </>
                            
                            </Routes>

                          <Footer />

                      </div>
      );
};

export default systeamWebsite;
